/*
 * @Author: dali crayoncrook@gmail.com
 * @Date: 2026-01-13 14:21:30
 * @LastEditors: dali crayoncrook@gmail.com
 * @LastEditTime: 2026-01-14 10:16:44
 * @FilePath: \gerlun-react-website\src\modules\loan.js
 */
import { API_LIST } from '@/const/api'
import BaseModule from './baseModule'

class Loan extends BaseModule {
  /**
   * 分页查询贷款意向机构。
   *
   * @param {{page: string, rows: string}} data 页码从 1 开始，rows 范围为 1-100
   * @returns {Promise<Object>} 机构分页结果，机构选中值使用 content[].orgNo
   */
  getOrgList(data) {
    return this.post({
      url: API_LIST.GET_LOAN_ORG_LIST,
      data
    })
  }

  /**
   * 分页查询已上架信贷产品。
   *
   * filterData 仅支持 acceptMode、userType、payMode、productType、usageInf 五个字符串数组，
   * 每组最多 10 项。sortDatas 最多 3 项，数组顺序表示优先级，仅支持期限、利率、金额排序。
   * 响应中的 acceptMode、acceptModeDesc、productOrgName、
   * productType、productTypeDesc 均按字符串数组契约透传。
   *
   * @param {{page: string, rows: string, filterData: Object<string, Array<string>>, sortDatas: Array<{sortParam: string, direction: 'ASC'|'DESC'}>}} data 查询条件
   * @returns {Promise<Object>} 产品分页结果
   */
  getProductListOnShelf(data) {
    return this.post({
      url: API_LIST.GET_PRODUCT_LIST_ONSHELF,
      data
    })
  }

  /**
   * 查询信贷产品详情（k3002）。
   *
   * productDescs 为结构化对象数组。详情顶层没有 enabled 字段；
   * productOrg.enabled 若存在则保留平台原始含义。
   *
   * @param {{productId: string}} query 产品标识
   * @returns {Promise<Object>} 产品详情
   */
  getProductDetails(query) {
    return this.get({
      url: API_LIST.GET_PRODUCT_DETAILS,
      query
    })
  }

  /**
   * 提交贷款申请单。
   *
   * @param {Object} data 按个人或企业贷款对象组装的申请报文
   * @returns {Promise<Object>} 申请提交结果
   */
  submitLoanApplyForm(data) {
    return this.post({
      url: API_LIST.SUBMIT_LOAN_APPLY,
      data
    })
  }
}

export default new Loan()
